import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

import { EUserRole } from '@shared/api/user-management/resources/user/constants/user-roles'

export const temboUsers = [
  {
    path: '/tembo-users',
    name: ERouterList.TEMBO_USERS,
    component: () => import('@internal/pages/tembo-users/index.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN],
      layout: InnerLayout,
    },
  },
  {
    path: '/tembo-users/create',
    name: ERouterList.TEMBO_USERS_CREATE,
    component: () => import('@internal/pages/tembo-users/create.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN],
      layout: InnerLayout,
    },
  },
  {
    path: '/tembo-users/:id',
    name: ERouterList.TEMBO_USERS_PROFILE,
    component: () => import('@internal/pages/tembo-users/_id/index.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN],
      layout: InnerLayout,
    },
  },
  {
    path: '/tembo-users/:id/edit',
    name: ERouterList.TEMBO_USERS_PROFILE_EDIT,
    component: () => import('@internal/pages/tembo-users/_id/edit.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN],
      layout: InnerLayout,
    },
  },
]

export default temboUsers
